const { baseUrl, apiKey } = window?.wvusFlexCheckoutSettings?.photoModConfig ?? {};

export default async function photoModerationUpload(base64Photo: string) {
  const photoModUrl = `${baseUrl}/photomoderation/upload?contentType=image/jpeg`;

  // Call photo moderation service
  const response = await fetch(photoModUrl, {
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
      "Ocp-Apim-Subscription-Key": `${apiKey}`
    },
    body: base64Photo
  });

  const data = await response.json();

  return data;
}
